
import axios from 'axios'
import store from '../store'
import { clearAll } from '../store/actions'

export default {
  login (data) {
    sessionStorage.removeItem('last_api_get')
    sessionStorage.setItem('username', data.userName)
    sessionStorage.setItem('isAdmin', data.isAdmin)
  },

  logout (dataStore) {
    sessionStorage.removeItem('last_api_get')
    store.state.user.isAuthenticated = false
    store.state.user.isAdmin = false
    clearAll(dataStore)
  },

  checkAuth () {
    // Check with backend if we are logged in
    axios.post('authentication/isloggedIn', { foo: null })
    .then((result) => {
      const data = result.data
      if (data.isLoggedIn === true) {
        store.state.user.isAuthenticated = true
        store.state.user.isAdmin = data.isAdmin
        store.state.user.name = data.userName
        sessionStorage.setItem('username', data.userName)
        sessionStorage.setItem('isAdmin', data.isAdmin)
      } else {
        store.state.user.isAuthenticated = false
        store.state.user.isAdmin = false
        store.state.user.name = ''
        store.state.expiresIn = ''
        sessionStorage.removeItem('username')
      }
    })
  }
}
